import config from '@/config';
import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { TaskQueryKey } from './queryKey';
export var useGetTaskWidgetKPIs = function (kpis) {
    var intl = useIntl();
    var _a = useQuery([TaskQueryKey.TaskWidgetKPI], function (_a) {
        var signal = _a.signal;
        return api.base
            .get("".concat(config.appUrls.tasks, "/api/plannedTasks/kpi/widget"), {
            params: {
                kpis: kpis,
            },
            signal: signal,
        })
            .then(function (res) { return res.data; });
    }, {
        enabled: true,
        onError: function (apiError) {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    }), data = _a.data, isLoading = _a.isLoading, error = _a.error, refetch = _a.refetch;
    return {
        data: data,
        error: error,
        isLoading: isLoading,
        refetch: refetch,
    };
};
